import UploadPreferredCSV from '@/explore/ffl-detail/licenseByZipQuery/uploadPreferredCSV'
import { analyticsEvents } from '@/utils/analyticsEvents';
import { logAnalyticsEvent } from '@/utils/analyticsLogger';
import { Button, useDisclosure } from '@chakra-ui/react';
import React from 'react'

function StoreProfile() {
    const {
        isOpen: preferredIsOpen,
        onOpen: preferredOnOpen,
        onClose: preferredOnClose
    } = useDisclosure();
    const preferredOnOpenHandler = ()=>{ logAnalyticsEvent(analyticsEvents.updateDealerPreferredStatus); preferredOnOpen();}
    return (
        <>
            <Button onClick={preferredOnOpenHandler}>Upload Preferred Dealers</Button>
            {preferredIsOpen && <UploadPreferredCSV isOpen={preferredIsOpen} onClose={preferredOnClose} />}
        </>
    )
}

export default StoreProfile